import posthog from "posthog-js";

posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY!, {
	api_host: "/ingest",
	person_profiles: "identified_only",
	defaults: "2025-05-24",
});

posthog.register({
	service: "web",
});
